import { createFileRoute } from '@tanstack/react-router';
import { SpacesChrome } from '@/components/spaces/SpacesChrome';
import { GroupsListBody } from '@/components/group/index';

type SpacesSearch = { q?: string };

export const Route = createFileRoute('/_authed/groups/')({
  validateSearch: (raw: Record<string, unknown>): SpacesSearch => {
    const q = typeof raw.q === 'string' && raw.q.length > 0 ? raw.q : undefined;
    return q !== undefined ? { q } : {};
  },
  component: SpacesListPage,
});

function SpacesListPage() {
  return (
    <SpacesChrome>
      <GroupsListBody kind="space" />
    </SpacesChrome>
  );
}
